module.exports = __webpack_public_path__ + "img/Infografis_EN_13.2fc33a68.jpg";